import React from "react";

export function SelectItem({ data, handleCheckItem }) {
	return (
		<div
			className="dropdownItem-19 selectedDropdownItem-202"
			onClick={handleCheckItem(data.id)}
		>
			<svg width="24" height="24" viewBox="0 0 24 24">
				<defs>
					<clipPath id="a">
						<path fill="#fff" d="M0 0H24V24H0z"></path>
					</clipPath>
				</defs>
				<path fill="none" d="M-1 -1H5.32432V5.32432H-1z"></path>
				<g clipPath="url(#a)">
					<path
						strokeWidth="3"
						stroke="#201F57"
						fill="#fff"
						d="M16.765 1.659c1.938.06 3.862.12 5.708.143l-.358 20.201c-3.308-.12-6.644-.019-10.025.12l-2.152.093c-2.76.12-5.556.242-8.438.275V1.836c3.33-.345 6.892-.375 10.501-.306 1.575.03 3.174.08 4.764.129z"
					></path>
				</g>
				{data.checked && (
					<path
						stroke="null"
						fillRule="evenodd"
						d="M16.344 7.916a1.113 1.108 0 011.589 1.55l-5.923 7.37a1.113 1.108 0 01-1.602.029l-3.925-3.908a1.113 1.108 0 111.573-1.565l3.107 3.09 5.153-6.534a.35.349 0 01.03-.032h-.002 0z"
						fill="#201F57"
					></path>
				)}
			</svg>
			<p className="MuiTypography-root MuiTypography-body2">{data.value}</p>
		</div>
	);
}
